import { makeAutoObservable } from 'mobx';

class Store {
  isPaused: boolean = false;
  activePopupId: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setIsPaused(value: boolean) {
    this.isPaused = value;
  }

  setActivePopupId(id: string | null) {
    this.activePopupId = id;
  }
}

export const PopupActionStore = new Store();
